import Journals from './Journals';
import JournalsContainer from './Journals.container';

export default JournalsContainer(Journals);
